import { Survey } from '@/utils/SurveyUtils';

/**
    draggedContext: context linked to dragged element
        index: dragged element index
        element: dragged element underlying view model element
        futureIndex: potential index of the dragged element if the drop operation is accepted
    relatedContext: context linked to current drag operation
        index: target element index
        element: target element view model element
        list: target list
        component: target VueComponent

 */

const validateMove = (evt: any) => {
  const item: any = evt.draggedContext.element;

  if (item.questiontype) {
    const page = evt.relatedContext.component.$attrs.page;
    if (page) {
      return true; // currently no validation done on the front end to see if a question can go in a page
    } else {
      return true; // page doesn't exist means this is the question box on the left
    }
  } else {
    if (evt.relatedContext.list.length > 0) {
      return evt.relatedContext.list[0].type === item.type;
    } else {
      return true; // content is empty and can be either a page or section
    }
  }
};

export default {
  validateMove,
};
